import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import {bindActionCreators} from 'redux';
import ellipsis from '/chat/src/common/js/lib/ellipsis';
import style from './style.scss';
import TextDisplay from '/chat/src/components/TextDisplay';

class FaqItem extends Component{

    render() {
        const faq = this.props.faq;
        const question = faq.question;
        const answer= faq.answer;
        const answerLength = faq.answer.length;
        const itemId = faq.id;
        const color = this.props.color;
        const handleItemClick = this.props.handleItemClick;
        const selectedItemId = this.props.selectedItemId;


        let itemColor = '';
        let arrowClassName = style.ArrowDown;



        let ellipsisStyle = style.ellipsis

        if(answerLength < 180){
            ellipsisStyle = ' '
        }
        if(selectedItemId === itemId && answerLength > 180){
            itemColor = '#FBFBFB';
            arrowClassName = style.ArrowUp;
            ellipsisStyle = ' '
        }

        let className = style.ItemWrapper;
        return (
            <div class={style.ItemWrapper} style={{background: itemColor}} onClick={()=>{handleItemClick(itemId)}}>
                <div className={style.ItemQuestion}>
                    <TextDisplay text={question}/>
                </div>
                <div className={style.ItemAnswer + ' ' + ellipsisStyle}>
                    <TextDisplay text={answer}/>
                {this.renderIcon(color, arrowClassName, answerLength)}
                </div>
            </div>
        );
    }

    renderIcon(color, arrowClassName, answerLength) {
        if(answerLength > 180){
            return(
                <span className={arrowClassName} style={{color: color}}></span>
            );
        }
    }

}

function mapStateToProps(state)
{
    return {
        faqs: state.get('faqs')
    };
}

export default connect(mapStateToProps)(FaqItem);



// WEBPACK FOOTER //
// ./routes/FAQ/FaqItem.js